import { MijnRoute } from '../../mijn-navigatie.model';

export const MORTGAGE_BUILD_FUND_TERMINATE_BEDANKT: MijnRoute = {
    path: 'bouwdepot/beeindigen/bedankt',
    navigationEvent: 'toBouwdepotBeeindigenBedankt',
    regex: /^\/hypotheek\/bouwdepot\/beeindigen\/bedankt$/,
    webcomponent: 'mijn-hypotheken-bouwdepot-webcomponent',
    internalPath: 'beeindigen/bedankt'
};
